







import Vue from 'vue';
import Component from 'vue-class-component';
import { Provide } from 'vue-property-decorator';
  import axios from 'axios';
  import * as $ from 'jquery';

@Component
export default class App extends Vue {




}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue